import styled from "styled-components";
import { Grid, IconButton } from "@mui/material";
import { DeleteForeverOutlined } from "@mui/icons-material";
import { ChannelStreamConfigCaptionInputWithId } from "./ChannelCaptions";

const Wrapper = styled.div`
    border-radius: 8px;
    background-color: ${(props) => props.theme.grayBackground};
    padding: 8px 6px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: space-between;
    align-items: center;
`;
const Label = styled.label`
    font-size: 13px;
    font-weight: bolder;
`;

interface Props {
    caption: ChannelStreamConfigCaptionInputWithId;
    onChangeCaption: (track: ChannelStreamConfigCaptionInputWithId) => void;
    onRemove: () => void;
    disabled?: boolean;
    allChannels: number[];
    allLabels: string[];
}

const Input = styled.input.attrs((props: { disabled: boolean; error: boolean }) => ({
    disabled: props.disabled,
    error: props.error,
}))`
    font-size: 14px;
    border: 1px solid ${(props) => (props.error ? props.theme.error : props.theme.lightGrayBottom)};
    border-radius: 6px;
    padding: 6px 10px;
    outline: rgba(0, 0, 0, 0.6);
    color: #696969;
    width: 100%;
    cursor: ${(props) => (props.disabled === true ? "not-allowed" : "text")};
`;

export default function ChannelCaption({
    onRemove,
    caption,
    onChangeCaption,
    disabled,
    allLabels,
    allChannels,
}: Props): JSX.Element {
    const { label, language, channel } = caption;
    return (
        <Wrapper>
            <Grid container spacing={1}>
                <Grid item xs={12} md={4}>
                    <Label>Channel</Label>
                    <Input
                        disabled={disabled}
                        value={channel}
                        min={0}
                        type="number"
                        error={channel < 0 || allChannels.includes(channel)}
                        onChange={(e) =>
                            onChangeCaption({
                                ...caption,
                                channel: parseInt(e.target.value),
                            })
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Label>Language</Label>
                    <Input
                        disabled={disabled}
                        value={language}
                        error={language.trim().length === 0}
                        onChange={(e) =>
                            onChangeCaption({
                                ...caption,
                                language: e.target.value,
                            })
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Label>Label</Label>
                    <Input
                        disabled={disabled}
                        value={label}
                        error={allLabels.includes(label)}
                        onChange={(e) =>
                            onChangeCaption({
                                ...caption,
                                label: e.target.value,
                            })
                        }
                    />
                </Grid>
            </Grid>
            {disabled !== true && (
                <div>
                    <IconButton size="small" onClick={onRemove}>
                        <DeleteForeverOutlined color="error" fontSize="small" />
                    </IconButton>
                </div>
            )}
        </Wrapper>
    );
}
